import { useMemo } from "react";
import {
  streamQueryParams as baseStreamQueryParams,
  courseQueryParams as baseCourseQueryParams,
  countryQueryParams as baseCountryQueryParams,
  stateQueryParams as baseStateQueryParams,
  citiesQueryParams as baseCitiesQueryParams,
  collegesQueryParams as baseCollegesQueryParams,
  topCollegesQueryParams as baseTopCollegesQueryParams,
  faqStudyAbroadParams as baseFaqStudyAbroadParams,
  categoryParams as baseCategoryParams,
  examsQueryParams as baseExamsQueryParams,
  topExamsQueryParams as baseTopExamsQueryParams,
} from "./queryParams";
import { useEntityData } from "../hooks/useEntityData";

export const useStreamData = () => {
  const streamQueryParams = useMemo(() => baseStreamQueryParams, []);
  const { data: streams }: any = useEntityData("streams", streamQueryParams);
  return { streamData: streams?.data?.results };
};

export const useCourseData = () => {
  const courseQueryParams = useMemo(() => baseCourseQueryParams, []);
  const { data: courses }: any = useEntityData("courses", courseQueryParams);
  return { courseData: courses?.data?.results };
};

export const useCountryData = (shouldFetch = true) => {
  const countryQueryParams = useMemo(() => baseCountryQueryParams, []);
  const { data: countries }: any = useEntityData(
    "countries",
    countryQueryParams,
    shouldFetch
  );
  return { studyAbroadData: countries?.data?.results };
};

export const useStateData = (shouldFetch = true) => {
  const stateQueryParams = useMemo(() => baseStateQueryParams, []);
  const { data: states }: any = useEntityData(
    "states",
    stateQueryParams,
    shouldFetch
  );
  return { statesData: states?.data?.results };
};

export const useCityData = (shouldFetch = true) => {
  const citiesQueryParams = useMemo(() => baseCitiesQueryParams, []);
  const { data: cities }: any = useEntityData(
    "cities",
    citiesQueryParams,
    shouldFetch
  );
  return { citiesData: cities?.data?.results };
};

export const useCollegeData = () => {
  const collegesQueryParams = useMemo(() => baseCollegesQueryParams, []);
  const { data: colleges }: any = useEntityData(
    "colleges",
    collegesQueryParams
  );
  return { collegeData: colleges?.data?.results };
};

export const useTopCollegeData = () => {
  const topCollegesQueryParams = useMemo(() => baseTopCollegesQueryParams, []);
  const { data: topCollegesData }: any = useEntityData(
    "colleges",
    topCollegesQueryParams
  );
  return { topCollegeData: topCollegesData?.data?.results };
};

export const useExamData = () => {
  const examsQueryParams = useMemo(() => baseExamsQueryParams, []);
  const { data: exams }: any = useEntityData("exams", examsQueryParams);
  return { examData: exams?.data?.results };
};

export const useTopExamData = () => {
  const topExamsQueryParams = useMemo(() => baseTopExamsQueryParams, []);
  const { data: topExamData }: any = useEntityData(
    "exams",
    topExamsQueryParams
  );
  return { topExamData: topExamData?.data?.results };
};
export const useTopCourseData = () => {
  const topCourseQueryParams = useMemo(() => baseCourseQueryParams, []);
  const { data: topCourseData }: any = useEntityData(
    "courses",
    topCourseQueryParams
  );
  return { topCourseData: topCourseData?.data?.results };
};


export const useFaqStudyAbroadData = () => {
  const faqStudyAbroadParams = useMemo(() => baseFaqStudyAbroadParams, []);
  const { data: faqStudyAbroad }: any = useEntityData(
    "study-abroad-faqs",
    faqStudyAbroadParams
  );
  return { faqStudyAbroadData: faqStudyAbroad?.data?.results };
};

export const useCategoryData = () => {
  const categoryParams = useMemo(() => baseCategoryParams, []);
  const { data: categoryData }: any = useEntityData(
    "categories",
    categoryParams
  );
  return { categoriesData: categoryData?.data?.results };
};
